module.exports = new __parcel__URL__("background_Tall.03bfeb9a.png").toString();